import { Component, EventEmitter, Output, Input } from '@angular/core';
import { IonButton, IonIcon, IonGrid, IonRow, IonCol } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { backspace } from 'ionicons/icons';
import { CommonModule } from '@angular/common';

// Register icons
addIcons({ backspace });

@Component({
  selector: 'crowdctrl-numeric-keyboard',
  standalone: true,
  imports: [CommonModule, IonButton, IonIcon, IonGrid, IonRow, IonCol],
  templateUrl: './numeric-keyboard.component.html',
  styleUrl: './numeric-keyboard.component.css',
})
export class NumericKeyboardComponent {
  @Input() minLength: number = 1;
  @Input() maxLength: number = 12;
  @Input() value: string = '';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  readonly digits = [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
  ];

  onDigitClick(digit: number): void {
    if (this.disabled) return;
    if (this.value.length < this.maxLength) {
      const newValue = this.value + digit.toString();
      this.value = newValue;
      this.valueChange.emit(newValue);
    }
  }

  onBackspaceClick(): void {
    if (this.disabled) return;
    if (this.value.length > 0) {
      const newValue = this.value.slice(0, -1);
      this.value = newValue;
      this.valueChange.emit(newValue);
    }
  }

  get isBackspaceDisabled(): boolean {
    return this.value.length === 0;
  }

  get isDigitDisabled(): boolean {
    return this.value.length >= this.maxLength;
  }
}
